export default __webpack_public_path__ + "9013a8d2b18000797270e72c7ebe18e4.png";